import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "border-default text-blue d-flex justify-content-center cursor-pointer",
  style: {"width":"50px"}
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonBack',
  setup(__props) {

// No props or logic needed for this simple component

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, { class: "text-blue" }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("mdi-arrow-left ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})